import { render } from "./SubscriptionList.vue?vue&type=template&id=0b52d67c&scoped=true"
import script from "./SubscriptionList.vue?vue&type=script&lang=js"
export * from "./SubscriptionList.vue?vue&type=script&lang=js"

import "./SubscriptionList.vue?vue&type=style&index=0&id=0b52d67c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b52d67c"]])

export default __exports__